import { Route, Routes } from 'react-router-dom';
import About from '@/pages/About';
import Home from '@/pages/Home';
import Landing from '@/pages/Landing';

export enum AppRoutes {
  LANDING = '/',
  APP = '/app',
  ABOUT = '/about',
}

const AppRouter = () => {
  return (
    <Routes>
      <Route path={AppRoutes.LANDING} element={<Landing />} />
      <Route path={AppRoutes.APP} element={<Home />} />
      <Route path={AppRoutes.ABOUT} element={<About />} />
    </Routes>
  );
};

export default AppRouter;
